import * as React from "react";
import * as yup from "yup";
import { Formik, Field } from "formik";
import { UserContext } from "../contexts/user";
import { useParams } from "react-router-dom";
import { useContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Box,
  Snackbar,
  Tab,
  Chip,
  Typography,
  Button,
  Table,
  TableCell,
  TableRow,
  Grid,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import LoadingButton from "@mui/lab/LoadingButton";
import EditUserForm from "../components/Forms/EditUserForm";
import Loading from "./Loading";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import KeyIcon from "@mui/icons-material/Key";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MuiAlert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { formatDate, formatDateStr } from "../helper";
import PageTitles from "../components/Layout/PageTitles";
import LogsTable from "../components/Tables/LogsTable";

const UserAccount = () => {
  const currentAdmin = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [userError, setUserError] = useState(null);
  const [subError, setSubError] = useState(null);
  const [subData, setUserSub] = useState([]);
  const { user } = useParams();
  const [value, setValue] = useState("1");
  const [expanded, setExpanded] = useState(false);
  const [passwordBtn, setPasswordBtn] = useState(false);
  const [userUpdated, setUserUpdated] = useState();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [alertColour, setAlertColour] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`/userSub/${user}`)
      .then((res) => {
        let resData = res.data.subscription
        resData.expiry = formatDate(resData.expiry);
        setUserSub(resData);
      })
      .catch((err) => {
        
        setSubError(err.message);
      });

    axios
      .get(`/userRec/${user}`)
      .then((res) => {
        let resData = res.data.user
        resData.startDate = formatDateStr(resData.startDate);
        resData.endDate = formatDateStr(resData.endDate);
        setUserData(resData);
      })
      .then(() => {
        if (userData) {
          setIsLoading(false);
        }
      })
      .catch((err) => {   
        setUserError(err.response);
      });
  }, [userUpdated]);

  //optomisting rendering alert for reset password and edit user

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleAccordianChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const getPassword = (setFieldValue) => {
    setBtnLoading(true);
    axios
      .get("/get_password")
      .then((res) => {
        setFieldValue("password", res.data.password);
        setBtnLoading(false);
      })
      .then(() => {
        setBtnLoading(false);
        setPasswordBtn(!passwordBtn);
      });
  };

  const savePassword = (values) => {
    let password = values.password;
    axios
      .patch("/new_password", { password: password, username: user })
      .then((res) => {
        setAlertColour("success");
        setMessage(res.data);
        setExpanded(false);
        setPasswordBtn(false);
        setOpen(true);
      })

      .catch((err) => {
        setAlertColour("error");
        setMessage(err.response.data);
        setOpen(true);
      });
  };

  const handleDelete = (user) => {
    axios
      .delete(`/delete_user/${user}`)
      .then((res) => {
        setAlertColour("success");
        setMessage(res.data);
        setOpen(true);
      })
      .then(() => {
        setTimeout(() => {
          navigate(`/users`);
        }, "3000");
      })
      .catch((err) => {
        setAlertColour("error");
        setMessage(err.response.data);
        setOpen(true);
      });
    axios.delete(`/delete_user/${user}`).then(() => {
      navigate(`/users`);
    });
  };

  const initialValues = {
    password: "",
  };

  const passwordSchema = yup.object().shape({
    password: yup
      .string()
      .min(8, "Too Short!")
      .max(35, "Too Long!")
      .required("Required"),
  });

  if (userError) {
    return <h1> No user </h1>;
  }

  return (
    <Box>
      <PageTitles title={"User details"} />
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "#212121",
            fontWeight: "bold",
          }}
        >
          <TabList onChange={handleTabChange} aria-label="lab API tabs example">
            <Tab label="Account Details" value="1" />
            <Tab label="Billing" value="2" />
            <Tab label="Logs" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">
          {isLoading && <Loading />}
          {isLoading === false && (
            <>
              <Typography
                color="primary"
                variant="h3"
                sx={{
                  mb: "20px",
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {" "}
                <AccountCircleIcon sx={{ mr: "10px", fontSize: "1em" }} />{" "}
                {userData.firstName} {userData.lastName} &#40;{" "}
                {userData.username} &#41;{" "}
              </Typography>

              <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleAlertClose}
              >
                {
                  <Alert
                    onClose={handleAlertClose}
                    severity={alertColour}
                    sx={{ width: "100%" }}
                  >
                    {message}
                  </Alert>
                }
              </Snackbar>

              <Box sx={{ display: "flex", mb: "20px" }}>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5"> Account details</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        "& .tableHeader": {
                          color: "#A020F0",
                          fontWeight: "Bold",
                          fontSize: "1em",
                        },
                      }}
                    >
                      <Table
                        sx={{
                          backgroundColor: "#212121",
                          mt: "20px",
                          p: "5px",
                        }}
                      >
                        <tbody>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Name
                            </TableCell>
                            <TableCell>
                              <Typography>
                                {userData.firstName + " " + userData.lastName}
                              </Typography>
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Account status
                            </TableCell>
                            <TableCell>
                              {userData.state === "Active" && (
                                <Chip
                                  label={userData.state}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#4caf50",
                                    ml: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                              {userData.state !== "Active" && (
                                <Chip
                                  label={userData.state}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#f44336",
                                    ml: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Account type
                            </TableCell>
                            <TableCell>
                              {userData.accountType === "plus" && (
                                <Chip
                                  label={userData.accountType}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#6a1b9a",
                                    ml: "5px",
                                    mt: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                              {userData.accountType === "view" && (
                                <Chip
                                  label={userData.accountType}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#2196f3",
                                    ml: "5px",
                                    mt: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                              {userData.accountType === "free" && (
                                <Chip
                                  label={userData.accountType}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#ff9800",
                                    ml: "5px",
                                    mt: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                              {userData.accountType === "admin" && (
                                <Chip
                                  label={userData.accountType}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#009688",
                                    ml: "5px",
                                    mt: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                              {userData.accountType === "standard" && (
                                <Chip
                                  label={userData.accountType}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#01579b",
                                    ml: "5px",
                                    mt: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                              {userData.genAccount === true && (
                                <Chip
                                  label="Generic"
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#18ffff",
                                    ml: "5px",
                                    mt: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Email
                            </TableCell>
                            <TableCell>
                              <Typography>{userData.email}</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Organisation
                            </TableCell>
                            <TableCell>
                              <Typography>
                                <a href={"../orgs/" + subData.keyId}>
                                  {subData.orgName}
                                </a>
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Account valid from
                            </TableCell>
                            <TableCell>
                              <Typography>{userData.startDate}</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Account expiry
                            </TableCell>
                            <TableCell>
                              <Typography>{userData.endDate}</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              MFA ?
                            </TableCell>
                            <TableCell>
                              {userData.mfaKey == null && (
                                <Typography
                                  sx={{
                                    flexShrink: 0,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {" "}
                                  <CancelRoundedIcon
                                    fontSize="small"
                                    sx={{ color: "#f44336", mr: "5px" }}
                                  />
                                  Not enabled
                                </Typography>
                              )}
                              {userData.mfaKey !== null && userData.mfaKey}
                            </TableCell>
                          </TableRow>
                        </tbody>
                      </Table>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="h5">Subscription details</Typography>
                    {subError && (
                      <div>
                        <Typography>
                          Could not access subscription information
                        </Typography>
                      </div>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        "& .tableHeader": {
                          color: "#A020F0",
                          fontWeight: "Bold",
                          fontSize: "1em",
                        },
                      }}
                    >
                      <Table sx={{ backgroundColor: "#212121", mt: "20px" }}>
                        <tbody>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Key number
                            </TableCell>
                            <TableCell>
                              <Typography sx={{ wordBreak: "break-word" }}>
                                {subData.keyNum}
                              </Typography>
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              {" "}
                              Expiry
                            </TableCell>
                            <TableCell>
                              <Typography>{subData.expiry}</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Key owner
                            </TableCell>
                            <TableCell>
                              <Typography>{subData.owner}</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Key type
                            </TableCell>
                            <TableCell>
                              <Typography>{subData.keyType}</Typography>
                            </TableCell>
                          </TableRow>
                        </tbody>
                      </Table>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              <Box>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleAccordianChange("panel1")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography
                      sx={{
                        width: "70%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {" "}
                      <PersonOutlineIcon sx={{ mr: "10px" }} />
                      Edit user details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {expanded === "panel1" && (
                      <EditUserForm
                        setExpanded={setExpanded}
                        setUserUpdated={setUserUpdated}
                        setUserError={setUserError}
                        setOpen={setOpen}
                        setMessage={setMessage}
                        setAlertColour={setAlertColour}
                      />
                    )}
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleAccordianChange("panel2")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography
                      sx={{
                        width: "70%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {" "}
                      <KeyIcon sx={{ mr: "10px" }} /> Reset users password
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{
                        mt: "5px",
                        mb: "5px",
                        backgroundColor: "#212121",
                        p: "20px",
                        display: "flex",
                        alignItems: "end",
                      }}
                    >
                      <Formik
                        onSubmit={savePassword}
                        initialValues={initialValues}
                        validationSchema={passwordSchema}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          setFieldValue,
                          handleBlur,
                          handleSubmit,
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <TextField
                              name="password"
                              label="password"
                              id="password"
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={!!touched.password && !!errors.password}
                              helperText={touched.password && errors.password}
                            />

                            <LoadingButton
                              variant="contained"
                              size="medium"
                              loading={btnLoading}
                              sx={{
                                ml: "10px",
                                mr: "10px",
                                mt: "10px",
                                mb: "10px",
                                backgroundColor: "#2196f3",
                                "&:hover": { backgroundColor: "#0d47a1" },
                              }}
                              onClick={() => {
                                getPassword(setFieldValue);
                              }}
                            >
                              create a new password
                            </LoadingButton>
                            <Button
                              type="submit"
                              value="Submit"
                              size="medium"
                              sx={{
                                ml: "10px",
                                mr: "10px",
                                mt: "10px",
                                mb: "10px",
                                color: "#121212",
                                backgroundColor: "#ce93d8",
                                "&:hover": { backgroundColor: "#a441b4" },
                                p: "5px",
                              }}
                            >
                              Submit
                            </Button>
                          </form>
                        )}
                      </Formik>
                    </Box>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleAccordianChange("panel3")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                    disabled={userData.username !== "admin" && true}
                  >
                    <Typography
                      sx={{
                        width: "70%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <TransferWithinAStationIcon sx={{ mr: "10px" }} /> Switch
                      to user
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{
                        mt: "5px",
                        backgroundColor: "#212121",
                        p: "20px",
                        display: "flex",
                      }}
                    >
                      {" "}
                      <Typography sx={{ ml: "5px" }}>
                        Please enter your password to switch to {user}'s
                        account:
                      </Typography>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        sx={{ m: "5px" }}
                      />{" "}
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ ml: "10px" }}
                      >
                        Switch
                      </Button>{" "}
                    </Box>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleAccordianChange("panel4")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                  >
                    <Typography
                      sx={{
                        width: "70%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {" "}
                      <DeleteIcon sx={{ mr: "10px" }} /> Delete user
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{
                        mt: "5px",
                        backgroundColor: "#212121",
                        display: "flex",
                        padding: "20px",
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => {
                          handleDelete(user);
                        }}
                        sx={{
                          ml: "10px",
                          maxHeight: "30px",
                          backgroundColor: "#ff3d00",
                          "&:hover": { backgroundColor: "#dd2c00" },
                        }}
                      >
                        Delete user: {user}
                      </Button>{" "}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>
            </>
          )}
        </TabPanel>
        <TabPanel value="2">Item Two</TabPanel>
        <TabPanel value="3">
          <LogsTable username={user} />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default UserAccount;
